const currentUrl = window.location.href;
const containerNF = document.querySelector(".fourohfour--container");

if (currentUrl.includes("/rootwise/verify")) {
  const code = new URL(currentUrl).searchParams.get("code");
  console.log("Code:", code);


  containerNF.innerHTML = `
    <div>
      <p>Verifying your code...</p>
    </div>
  `;

  containerNF.classList.remove("custom-hidden");

  async function getClientIP() {
    try {
      const res = await fetch("https://api.ipify.org?format=json");
      const data = await res.json();
      return data.ip;
    } catch (err) {
      console.warn("Failed to fetch client IP:", err);
      return ""; // fallback empty if blocked
    }
  }

  async function verifyCode(code) {
    try {
      // 🗺️ Get geolocation (optional)
      const position = await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject, { timeout: 5000 });
      }).catch(() => null);

      const callerLocation = position
        ? {
            latitude: position.coords.latitude.toString(),
            longitude: position.coords.longitude.toString(),
          }
        : { latitude: "", longitude: "" };

      // 🌐 Get client public IP
      const callerIp = await getClientIP();

      const payload = {
        code,
        callerIp,
        callerLocation,
        userLanguage: navigator.language || "en-US",
        requestInfo: {
          userAgent: navigator.userAgent,
          referrerUrl: document.referrer,
          browserCulture: navigator.language || "en-US",
        },
      };

      console.log("Payload being sent:", payload);

      const response = await fetch(
        "https://baumannwisconsinginseng.info/verify.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();
      console.log("Response:", data);

      if (response.ok && data.status === "success") {
        window.location.href = "/pages/verify?c3VjY2Vzcw==";
      } else {
        window.location.href = "/pages/verify?ZmFpbGVk";
      }
    } catch (err) {
      console.error("Error verifying code:", err);
      window.location.href = "/pages/verify?ZmFpbGVk";
    }
  }

  if (code) {
    verifyCode(code);
  } else {
    containerNF.innerHTML = `<p>No verification code found in URL.</p>`;
  }
}else{
    containerNF?.classList.remove("custom-hidden");
}

const successBox = document.getElementById("custom-verify-success");
const failedBox  = document.getElementById("custom-verify-failed");

if (currentUrl.includes("?ZmFpbGVk")) {
    failedBox.style.display = "block";
    successBox.style.display = "none";
} else if(currentUrl.includes("?c3VjY2Vzcw==")){
    successBox.style.display = "block";
    failedBox.style.display = "none";
}

// if (currentUrl.includes("?verification-failed")) {
//    console.log("failed")
// }else if(currentUrl.includes("?verified")){
//   console.log("success")
// }

// const url = window.location.href;
// console.log(url, "url");

// const successBox = document.getElementById("custom-verify-success");
// const failedBox  = document.getElementById("custom-verify-failed");

// if (url.includes("verification-failed")) {
//     failedBox.classList.remove('cus-hidden')
//     successBox.classList.add('cus-hidden')
// } else if (url.includes("verification-success")) {
//     successBox.classList.remove('cus-hidden')
//     failedBox.classList.add('cus-hidden')
// }
